import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import React, { ReactNode } from 'react';

export const PaywallSubmitConfirmed: React.FC<{
  open: boolean;
  title: string;
  body: ReactNode;
  onClose: () => void;
}> = ({ title, body, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle variant="h3">{title}</DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
